<div>
    Health Insight 360 © 2010-{{ year }}
</div>
<div class="hidden md:block lg:block xl:block">
    Powered by Angular v19 -{{ appInfo.sourceBranch }}_{{ appInfo.buildNumber }}
</div>